import React, { Component } from 'react';

export default class SliderLayout extends Component {
	render() {
		let { children, currentStep } = this.props
		let sliderWidth = 100 * children.length
		let childrenWidth = 100 / children.length
		return (
			<div className="SliderLayout">
				<div className="slider-container">
					<div
						className="slider"
						style={{ width: sliderWidth + '%', transform: `translateX(${-currentStep * childrenWidth}%)` }}
					>
						{children.filter((c, i) => i === currentStep).map((child, i) =>
							<div key={i} className="slide" ref={"slide-" + i}
								style={{ width: childrenWidth + '%', transform: `translateX(${currentStep * 100}%)` }}
							>
								{child}
							</div>
						)}
					</div>
				</div>
			</div>
		)
	}
}

SliderLayout.defaultProps = {
	children: []
}



// WEBPACK FOOTER //
// ./src/components/SliderLayout.js